import React from "react";
import { GridType } from "../../../../../types/grid";
import Grid from "../../../../atoms/Grid";

import type { GetBillingScheduleResult, TorPinnedRow } from "../Commercial/add-plan/api";
import { RowClassParams } from "ag-grid-community";

type ViewTORScheduleProps = {
  rows: GetBillingScheduleResult["torschedule"];
  columns: GridType[]; // make columns optional to allow for defaulting
  grandTotalPinnedRow: TorPinnedRow[];
};

export const ViewTORSchedule = ({ rows, columns, grandTotalPinnedRow }: ViewTORScheduleProps) => {
  return (
    <Grid
      pinnedBottomRowData={grandTotalPinnedRow}
      fullPage
      className="p-0"
      columns={columns}
      data={rows}
      getRowStyle={({ node }: RowClassParams) => {
        if (node.rowPinned === "bottom") return { background: "var(--gray-100)", fontWeight: 600 };
      }}
    />
  );
};
